<template>
  <f7-page class="main-access-device-activity">
    <template #fixed>
      <TheNavbar
        nav-title="Act. Prod. Dispositivos de Acceso"
        back-btn-enable
      />
    </template>

    <f7-block class="main-worker-records no-margin padding bg-darkgray">
      <UCSearchEntityERP
        class="main-worker-records__search"
        :title="$t('searchEntity.productionActivity.title.productionActivitySearch')"
        :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
        :search-text="$t('searchEntity.productionActivity.searchText')"
        :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
        :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
        :end-point-for-code-search="ActivityCodeSearch"
        :end-point-for-list="ActivityList"
        :property-entity-shown-input="['Codigo', 'Nombre']"
        :property-entity-shown-list-title="['Codigo']"
        :property-entity-shown-list-subtitle="['Nombre']"
        :enable="!showPreload && listDispositives.filter(d => d.PermiteCambioActividad).length > 0"
        @selection="EventSelectedProductionActivity"
      />
    </f7-block>
    <f7-block class="content-titulo-select no-margin padding bg-lightsnow">
      <label
        class="checkbox display-flex align-items-center"
      >
        <input
          v-model="checkAllDispositives"
          type="checkbox"
        >
        <i class="icon-checkbox margin-right" />
        Seleccionar Todos
      </label>
    </f7-block>
    <UCPreload :show="showPreload" />
    <f7-block class="content-list-checkbox no-padding-right no-margin">
      <div
        v-for="d in listDispositives.filter(e => e.PermiteCambioActividad)"
        :key="d.Id"
        no-gap
        class="content-list-checkbox-item"
      >
        <div>
          <div
            class="content-list-checkbox-item__title"
          >
            <div>
              <label class="checkbox">
                <input
                  :checked="d.checked"
                  type="checkbox"
                  @change="d.checked = !d.checked"
                >
                <i class="icon-checkbox" />
              </label>
              <div @click="ShowDeviceDetaills(d)">
                {{ TextMaximumLength(d.Nombre, 30) }}
              </div>
            </div>
          </div>
          <div
            class="content-list-checkbox-item__subtitle"
            @click="ShowDeviceDetaills(d)"
          >
            {{ d.ActividadProduccion.Nombre }}
          </div>
        </div>
      </div>
    </f7-block>
    <!-- Boton Flotante Asignar Actividad -->
    <f7-fab
      v-if="numberOfDispositivesSelected > 0"
      position="right-bottom"
      color="green"
      class="action-btn"
      @click="AssignProductionActivity()"
    >
      <img
        alt="iconSuffle"
        src="@/static/icons/ic_suffle.svg"
      >
    </f7-fab>
  </f7-page>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useProductionStore } from '@/js/stores/production';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { HiStringSupport } from '@/js/common/HIConversionSupport';
import APIErp from '@/js/services/APIErp';

import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import { f7 } from 'framework7-vue';

export default {
  name: 'FrmAccessDeviceActivity',
  components: {
    UCSearchEntityERP,
    UCPreload,
    TheNavbar,
  },

  data() {
    return {
      selectedActivity: null,
      listDispositives: [],
      showPreload: false,
    };
  },
  computed: {
    ...mapWritableState(useProductionStore, ['selectedAccessDevice']),

    checkAllDispositives: {
      get() {
        if (this.listDispositives.length === 0) {
          return false;
        }
        for (let i = 0; i < this.listDispositives.length; i += 1) {
          if (!this.listDispositives[i].checked) {
            return false;
          }
        }
        return true;
      },
      set(value) {
        this.listDispositives.forEach((item) => {
          item.checked = value;
        });
      },
    },
    numberOfDispositivesSelected() {
      // Los dispositivos que no permiten cambio de actividad no se visualizan en la APP.
      return this.listDispositives.filter((element) => element.checked === true && element.PermiteCambioActividad).length;
    },
  },

  mounted() {
    this.StartForm();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.GetAccessDevices();
    },

    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      // return APIErp.callProductionActivityList();
      return APIErp.callProductionActivityListAuthorized();
    },
    EventSelectedProductionActivity(objActivity) {
      Log(this, this.EventSelectedProductionActivity.name);
      this.selectedActivity = objActivity;
    },
    TextMaximumLength(text, numCharacters) {
      return HiStringSupport.TextMaximumLength(text, numCharacters);
    },
    GetAccessDevices() {
      const self = this;
      self.showPreload = true;
      this.Conections_GetAccessDevices().then((result) => {
        self.listDispositives = result;
        // Seleccionamos todos
        self.checkAllDispositives = true;
      }).catch((error) => {
        HiNotification.Toast(error);
      }).finally(() => {
        self.showPreload = false;
      });
    },
    AssignProductionActivity() {
      Log(this, this.AssignProductionActivity.name);
      if (this.selectedActivity === null) {
        HiNotification.Toast('Es necesario seleccionar la actividad de producción para establecer');
        return;
      }
      const listObjDispositivesSelected = [];
      this.listDispositives.forEach((item) => {
        if (item.checked && item.PermiteCambioActividad) {
          const objDispositive = item;
          objDispositive.ActividadProduccion = this.selectedActivity;
          listObjDispositivesSelected.push(objDispositive);
        }
      });
      const self = this;
      HiDialog.Preloader(true, 'Cambiando actividad de producción', true, this.searchCancellationText);
      this.Conections_ChangeActivityProductionDevice(listObjDispositivesSelected).then(() => {
        self.GetAccessDevices();
      }).catch((error) => {
        HiNotification.Toast(error);
      }).finally(() => {
        self.showPreload = false;
        HiDialog.Preloader(false);
      });
    },
    ShowDeviceDetaills(objDevice) {
      Log(this, this.ShowDeviceDetaills.name);
      this.selectedAccessDevice = objDevice;
      f7.views.main.router.navigate('/production/accessDevice/accessDeviceDetails');
    },

    Conections_GetAccessDevices() {
      return new Promise((resolve, reject) => {
        APIErp.callAccessDeviceList().then((result) => {
          resolve(result.data);
        })
          .catch((error) => {
            reject(error);
            LogError(this, this.Conections_GetAccessDevices.name, error);
          });
      });
    },
    Conections_ChangeActivityProductionDevice(listObjDispositives) {
      return new Promise((resolve, reject) => {
        APIErp.callChangeActivityProductionDevice(listObjDispositives).then((result) => {
          resolve(result.data);
        })
          .catch((error) => {
            reject(error);
            LogError(this, this.Conections_ChangeActivityProductionDevice.name, error);
          });
      });
    },
  },

};
</script>

<style lang="scss">
.main-access-device-activity {
  // TODO: Remove when migrated to new styles
  --f7-checkbox-inactive-color: var(--his-silver);
  --f7-checkbox-active-color: var(--his-greenlight);
  --f7-checkbox-border-width: 1px;
  --f7-checkbox-border-radius: 6px;
  --f7-list-item-title-text-color: var(--his-teal-green);
  --f7-list-item-title-font-size: 15px;
  //
}

.main-worker-records {
  &.bg-darkgray {
    background-color: var(--his-darkgray);
  }

  .block-title {
    color: #fff;
    padding: 0 10px;
    margin: 0 0 10px;
  }

  &__search {
    --search-title-color: #fff;
  }
}

.main-new-massive-records,
.main-worker-records,
.main-worker-activity {
  .content-buscador {
    background-color: var(--his-darkgray);
    margin: 0;
    padding: 0 10px 10px;

    .block-title {
      margin: 0 0 10px 15px;
      color: #fff;
    }
  }

  .content-titulo-select {
    background-color: var(--his-tierra-white);
    padding-top: 15px;
    padding-bottom: 15px;
    margin: 0;

    label {
      display: flex;
      align-items: center;
    }
  }

  input[type="checkbox" i] {
    background-color: red;
  }
}

.action-btn {
  img {
    height: 56px;
    width: 56px;
  }
}
</style>
